import { VIPEvent } from "@/loader";
import dayjs from "dayjs";

export interface IEventInfo {
	date?: string;
	type?: string;
	description?: string;
}

export interface IEventRelation {
	fk_event: number;
	event: VIPEvent | null;
}

export interface IEventable {
	event: IEventInfo | null;
	events: IEventRelation[];
}

export function createEventInfo(type?: string, description?: string) {
	return {
		date: dayjs().format("YYYY-MM-DD HH:mm:ss"),
		type,
		description,
	};
}
